import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_solaro-founding/artifacts/6pe0ovti_Solaro%20Capri%20Gin%20-%20Horizontal%20Vectorial%20Handpainted%20PNG%20TRANSPARENT.png";
const BG_IMAGE = "https://images.unsplash.com/photo-1721034634766-501babee5ba9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjYXByaSUyMGNvYXN0JTIwbWVkaXRlcnJhbmVhbiUyMHN1bW1lciUyMGx1eHVyeXxlbnwwfHx8fDE3NzM4Mjk2MTZ8MA&ixlib=rb-4.1.0&q=85";

export default function AgeGate({ onVerified }) {
  const [year, setYear] = useState("");
  const [error, setError] = useState("");

  const handleVerify = () => {
    setError("");
    const y = parseInt(year, 10);

    if (!y || y < 1900 || y > new Date().getFullYear()) {
      setError("Please enter a valid birth year");
      return;
    }

    const age = new Date().getFullYear() - y;

    if (age < 18) {
      setError("You must be 18 or older to access this page");
      return;
    }

    onVerified();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleVerify();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="age-gate">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-[#002366]/80 backdrop-blur-sm" />

      <div className="relative z-10 w-full max-w-sm mx-3 sm:mx-4 animate-fade-in-up">
        <div className="bg-white/95 backdrop-blur-md p-6 sm:p-10 text-center shadow-2xl">
          <img
            src={LOGO_URL}
            alt="Solaro Capri Gin"
            className="h-12 sm:h-20 mx-auto mb-6 sm:mb-8 object-contain"
            data-testid="age-gate-logo"
          />

          <h1 className="font-display text-xl sm:text-3xl text-[#002366] mb-2 tracking-tight">
            Welcome
          </h1>
          <p className="font-body text-sm text-[#1A2B4C]/60 mb-6 sm:mb-8 tracking-wide">
            Enter your birth year to continue
          </p>

          <div className="max-w-[180px] mx-auto mb-6">
            <Label className="text-xs uppercase tracking-widest text-[#1A2B4C]/50 font-body mb-2 block">
              Birth Year
            </Label>
            <Input
              data-testid="age-gate-year"
              type="text"
              inputMode="numeric"
              placeholder="YYYY"
              maxLength={4}
              value={year}
              onChange={(e) => setYear(e.target.value.replace(/\D/g, ""))}
              onKeyDown={handleKeyDown}
              className="text-center text-2xl font-display border-[#D1CFC7] focus:border-[#002366] focus:ring-[#D4AF37] bg-white h-14"
            />
          </div>

          {error && (
            <p className="text-[#EA580C] text-sm mb-4 font-body" data-testid="age-gate-error">
              {error}
            </p>
          )}

          <Button
            data-testid="age-gate-verify-btn"
            onClick={handleVerify}
            className="w-full bg-[#002366] text-white hover:bg-[#001133] rounded-none uppercase tracking-widest text-sm px-8 py-6 transition-all duration-300"
          >
            Enter
          </Button>

          <p className="text-xs text-[#1A2B4C]/40 mt-6 font-body leading-relaxed">
            By entering this site, you confirm you are of legal drinking age in your country of residence.
          </p>
        </div>
      </div>
    </div>
  );
}
